export default __webpack_public_path__ + "static/11_vastint-881fef2c98d69cf42b63b03e62747c9e.png";